export function isIos() {
  var ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1;
}

export function isAppleMac() {
  var ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('macintosh') > -1;
}

export function isAndroid() {
  var ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('android') > -1;
}

export function isMobileOs() {
  return isIos() || isAndroid();
}
